import { all, call, put, takeLatest } from 'redux-saga/effects';
import { fetchClient } from '../utilities/fetchClient';
import ActionTypes from '../actions/actionTypes';
import {
  getCashOrdersListSuccess,
  getCashOrdersListFailure,
  getCashOrderDetailsSuccess,
  getCashOrderDetailsFailure,
  getCashOrderDefaultsSuccess,
  getCashOrderDefaultsFailure,
  createCashOrderSuccess,
  createCashOrderFailure,
  activateAllCardsSuccess,
  activateAllCardsFailure,
  getCashCardDetailsSuccess,
  getCashCardDetailsFailure,
  activateAllCardsReset,
} from '../actions/cashActions';
import Env from '../Env';
import { addToastAlert } from 'actions/toastAlertActions';
import Alert from 'constants/alert-messages';

function* getCashOrdersList(action) {
  const header = {
    'Ocp-Apim-Subscription-Key': Env.getApimKey(),
  };
  try {
    const { grandParentAccountNumber, accountNumber, ...queryParams } = action.payload;

    const response = yield call(fetchClient, {
      url: `cards-api/v1/ampolcash/${grandParentAccountNumber}/${accountNumber}/orders`,
      method: 'GET',
      apiServer: Env.getApimBaseUrl(),
      headers: header,
      queryParams: {
        ...queryParams,
      },
    });
    yield put(getCashOrdersListSuccess(response));
  } catch {
    yield put(getCashOrdersListFailure());
  }
}

function* getCashOrderDetails(action) {
  const header = {
    'Ocp-Apim-Subscription-Key': Env.getApimKey(),
  };
  try {
    const { orderNumber, grandParentAccountNumber, contractIdentifier, ...queryParams } = action.payload;

    const response = yield call(fetchClient, {
      url: `cards-api/v1/ampolcash/${grandParentAccountNumber}/${contractIdentifier}/orders/${orderNumber}`,
      method: 'GET',
      apiServer: Env.getApimBaseUrl(),
      headers: header,
      queryParams: {
        ...queryParams,
      },
    });
    yield put(getCashOrderDetailsSuccess(response, action.payload.pageNumber));
  } catch {
    yield put(getCashOrderDetailsFailure());
  }
}

function* getCashCardDetails(action) {
  const header = {
    'Ocp-Apim-Subscription-Key': Env.getApimKey(),
  };
  try {
    const { orderNumber, grandParentAccountNumber, contractIdentifier, cardNumber } = action.payload;

    const response = yield call(fetchClient, {
      url: `cards-api/v1/ampolcash/${grandParentAccountNumber}/${contractIdentifier}/orders/${orderNumber}/cards/${cardNumber}`,
      method: 'GET',
      apiServer: Env.getApimBaseUrl(),
      headers: header,
    });
    yield put(getCashCardDetailsSuccess(response));
  } catch {
    yield put(getCashCardDetailsFailure());
  }
}

function* getCashOrderDefaults(action) {
  const header = {
    'Ocp-Apim-Subscription-Key': Env.getApimKey(),
  };
  try {
    const { grandParentAccountNumber, contractIdentifier } = action.payload;

    const response = yield call(fetchClient, {
      url: `cards-api/v1/ampolcash/${grandParentAccountNumber}/${contractIdentifier}/orders/defaults`,
      method: 'GET',
      apiServer: Env.getApimBaseUrl(),
      headers: header,
    });

    yield put(getCashOrderDefaultsSuccess(response));
  } catch {
    yield put(getCashOrderDefaultsFailure());
  }
}

function* createCashOrder(action) {
  const header = {
    'Ocp-Apim-Subscription-Key': Env.getApimKey(),
  };
  try {
    const { grandParentAccountNumber, accountNumber, request } = action.payload;

    const response = yield call(fetchClient, {
      url: `cards-api/v1/ampolcash/${grandParentAccountNumber}/${accountNumber}/orders`,
      method: 'POST',
      apiServer: Env.getApimBaseUrl(),
      headers: header,
      body: request,
    });
    yield put(createCashOrderSuccess(response));
  } catch {
    yield put(createCashOrderFailure());
    yield put(addToastAlert(Alert.CREATE_CASH_ERROR, 'error'));
  }
}

function* activateAllCards(action) {
  const header = {
    'Ocp-Apim-Subscription-Key': Env.getApimKey(),
  };
  try {
    const { grandParentAccountNumber, contractIdentifier, orderNumber } = action.payload;

    yield put(addToastAlert(Alert.ACTIVATE_ALL_LOADING));

    yield call(fetchClient, {
      url: `cards-api/v1/ampolcash/${grandParentAccountNumber}/${contractIdentifier}/order/${orderNumber}/activate`,
      method: 'POST',
      apiServer: Env.getApimBaseUrl(),
      headers: header,
    });
    yield put(activateAllCardsSuccess());
    yield put(addToastAlert(Alert.ACTIVATE_ALL_SUCCESS, 'success'));
    yield put(activateAllCardsReset());
  } catch {
    yield put(activateAllCardsFailure());
    yield put(addToastAlert(Alert.ACTIVATE_ALL_ERROR, 'error'));
    yield put(activateAllCardsReset());
  }
}

export default function* cashSaga() {
  yield all([
    takeLatest(ActionTypes.CASH.ORDERS_LIST.REQUEST, getCashOrdersList),
    takeLatest(ActionTypes.CASH.ORDER_DETAILS.REQUEST, getCashOrderDetails),
    takeLatest(ActionTypes.CASH.CARD_DETAILS.REQUEST, getCashCardDetails),
    takeLatest(ActionTypes.CASH.ORDER_DEFAULTS.REQUEST, getCashOrderDefaults),
    takeLatest(ActionTypes.CASH.CREATE_ORDER.REQUEST, createCashOrder),
    takeLatest(ActionTypes.CASH.ORDER_ACTIVATE_ALL_CARDS.REQUEST, activateAllCards),
  ]);
}
